<template>
  <v-container class="pa-0">
    <v-form ref="user-form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button v-if="this.options.edit == false" type="edit" @click="options.edit = true" />

        <span v-if="this.options.edit == true">
          <action-button type="cancel" @click="options.edit = false" />
          <action-button type="save" @click="update('user-form')" />
        </span>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout v-if="options.edit == true" row wrap>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.first_name"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('users.first_name')"
                  :error-messages="errors.collect('first_name')"
                  data-vv-name="first_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.middle_name"
                  :label="$t('users.middle_name')"
                  :error-messages="errors.collect('middle_name')"
                  data-vv-name="middle_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.last_name"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('users.last_name')"
                  :error-messages="errors.collect('last_name')"
                  data-vv-name="last_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.mobile"
                  :label="$t('users.mobile')"
                  :error-messages="errors.collect('mobile')"
                  data-vv-name="mobile"
                  name="mobile"
                  v-validate="'no_space'"
                  @blur="phoneNoSpace"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.email"
                  :label="$t('users.email')"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <br />
            </v-layout>

            <v-layout v-if="options.edit == false" row wrap>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.first_name"
                  :label="$t('users.first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.middle_name"
                  :label="$t('users.middle_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="user.person.last_name"
                  :label="$t('users.last_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field v-model="user.person.mobile" :label="$t('users.mobile')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>

              <v-flex lg4 md4 sm6 xs12>
                <v-text-field v-model="user.email" :label="$t('users.email')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("users.changepass") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg6 md6 xs12>
                <v-text-field
                  v-model="old_password"
                  v-validate="!this.id ? 'required' : ''"
                  :label="$t('users.edit.old_pass')"
                  :error-messages="errors.collect('old_pass')"
                  data-vv-name="old_password"
                  type="password"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg6 md6 xs12>
                <v-text-field
                  v-model="password"
                  data-vv-name="new_password"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('users.edit.new_pass')"
                  :error-messages="errors.collect('new_password')"
                  type="password"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>

              <v-flex lg6 md6 xs12>
                <v-text-field
                  v-model="password_confirmation"
                  class="required-field"
                  v-validate="'required|confirmed:new_password'"
                  :label="$t('users.edit.confirm_pass')"
                  :error-messages="errors.collect('confirm_pass')"
                  data-vv-name="password_confirmation"
                  data-vv-as="new_password"
                  ref="password"
                  type="password"
                  autocomplete="new-password"
                ></v-text-field>
                <label v-if="isPasswordMatch == false" class="red--text text--darken-2">{{ $t("users.edit.password_no_match") }}</label>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "UserProfile",
  props: ["id"],
  data() {
    return {
      page_title: this.$t("users.profile"),
      user: {},
      old_password: "",
      password: "",
      password_confirmation: "",
      options: {
        edit: false
      },
      dictionary: {
        attributes: {
          email: this.$t("users.email"),
          password: this.$t("users.password"),
          new_pass: this.$t("users.edit.new_pass"),
          old_pass: this.$t("users.edit.old_pass"),
          confirm_pass: this.$t("users.edit.confirm_pass"),

          first_name: this.$t("users.first_name"),
          middle_name: this.$t("users.middle_name"),
          last_name: this.$t("users.last_name"),
          mobile: this.$t("users.mobile")
        }
      }
    }
  },

  created() {
    let user = localStorage.getItem("__crrntUser")
    this.user = JSON.parse(user)
  },
  computed: {
    isPasswordMatch() {
      return this.password == this.password_confirmation ? true : false
    }
  },
  methods: {
    update(scope) {
      this.$validator.validate()

      this.$validator
        .validateAll(scope)
        .then((valid) => {
          if (valid) {
            let vm = this

            axios
              .post(this.API_URL + "user/profile/update", {
                id: vm.user.id,
                email: vm.user.email,
                first_name: vm.user.person.first_name,
                middle_name: vm.user.person.middle_name,
                last_name: vm.user.person.last_name,
                mobile: vm.user.person.mobile,
                old_pass: vm.old_password,
                password: vm.password
              })
              .then((res) => {
                vm.$awn.success(vm.$t("global.update_success"))
                this.password = ""
                this.old_password = ""
                this.password_confirmation = ""
              })
              .catch((err) => {
                vm.$awn.alert(vm.$t("global.update_failed"))
                this.password = ""
                this.old_password = ""
                this.password_confirmation = ""
                console.log(err)
              })

            vm.options.edit = false
          }
        })
        .catch(() => {})
    },
    mounted() {
      this.$validator.localize(this.$getSetting("locale"), this.dictionary)
    },
    phoneNoSpace() {
      if (this.user.person.mobile) {
        this.user.person.mobile = this.user.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    }
  }
}
</script>
